import Util from "../util";

// File#: _1_side-navigation
// Usage: codyhouse.co/license
(function () {
	function initSideNav(nav) {
		nav.addEventListener("click", function (event) {
			var btn = event.target.closest(".js-sidenav__sublist-control");
			if (!btn) return;
			var listItem = btn.parentElement,
				bool = Util.hasClass(listItem, "sidenav__item--expanded");
			btn.setAttribute("aria-expanded", !bool);
			Util.toggleClass(listItem, "sidenav__item--expanded", !bool);
		});
	}

	var sideNavs = document.getElementsByClassName("js-sidenav");
	if (sideNavs.length > 0) {
		for (var i = 0; i < sideNavs.length; i++) {
			(function (i) {
				initSideNav(sideNavs[i]);
			})(i);
		}
	}
})();

function initSideNav(nav) {
	nav.addEventListener("click", function (event) {
		var btn = event.target.closest(".js-sidenav__sublist-control");
		Util.toggleClass(btn, "sidenav--expanded", !bool);

		if (!btn) return;
		var listItem = btn.parentElement.querySelector('.sidenav__list'),
			bool = Util.hasClass(listItem, "sidenav__list--expanded");
		btn.setAttribute("aria-expanded", !bool);
		Util.toggleClass(listItem, "sidenav__list--expanded", !bool);
	});
}

function dashboardMenu() {
	var sideNavs = document.getElementsByClassName("js-dash-sidenav");
	if (sideNavs.length > 0) {
		for (var i = 0; i < sideNavs.length; i++) {
			(function (i) {
				initSideNav(sideNavs[i]);
			})(i);
		}
	}	
}

export default dashboardMenu

